import { render } from "./OptionsMenu.vue?vue&type=template&id=10190292&ts=true"
import script from "./OptionsMenu.vue?vue&type=script&lang=ts"
export * from "./OptionsMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__